import { createSelector } from '@ngrx/store';
import { State } from '@store/state';

const getProducts = (state: State) => state.products;

// ---- Email ----
export const getEmailProductsApiCall = createSelector(
  getProducts,
  (state) => state.emailEventTypesByProductId
);

export const getEmailEventTypesByProductIdMap = createSelector(
  getProducts,
  (state) => state.emailEventTypesByProductId.data
);

export const getEmailProductIds = createSelector(
  getEmailEventTypesByProductIdMap,
  (map) => Object.keys(map).sort((a, b) => a.localeCompare(b))
);

// ---- Public email ----
export const getPublicEmailProductsApiCall = createSelector(
  getProducts,
  (state) => state.publicEmailEventTypesByProductId
);

export const getPublicEmailEventTypesByProductIdMap = createSelector(
  getProducts,
  (state) => state.publicEmailEventTypesByProductId.data
);

export const getPublicEmailProductIds = createSelector(
  getPublicEmailEventTypesByProductIdMap,
  (map) => Object.keys(map).sort((a, b) => a.localeCompare(b))
);

// ---- SMS ----
export const getSmsProductsApiCall = createSelector(
  getProducts,
  (state) => state.smsEventTypesByProductId
);

export const getSmsEventTypesByProductIdMap = createSelector(
  getProducts,
  (state) => state.smsEventTypesByProductId.data
);

export const getSmsProductIds = createSelector(
  getSmsEventTypesByProductIdMap,
  (map) => Object.keys(map).sort((a, b) => a.localeCompare(b))
);

// ---- Chat singles ----
export const getChatSingleProductsApiCall = createSelector(
  getProducts,
  (state) => state.chatSingleCodesByProductId
);

export const getChatSingleCodesByProductIdMap = createSelector(
  getProducts,
  (state) => state.chatSingleCodesByProductId.data
);

// ---- Chat groups ----
export const getChatGroupProductsApiCall = createSelector(
  getProducts,
  (state) => state.chatGroupCodesByProductId
);

export const getChatGroupCodesByProductIdMap = createSelector(
  getProducts,
  (state) => state.chatGroupCodesByProductId.data
);

// ---- Channels ----
export const getChannelProductsApiCall = createSelector(
  getProducts,
  (state) => state.channelProductIds
);

export const getChannelProductIdsData = createSelector(
  getChannelProductsApiCall,
  (apiCall) => apiCall.data
);
